import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["addMoreButton"]
  static values = { trashImg: String}

  addMore(){
    const more_element = this.element.querySelector("div#more_element");
    const floorPlan = this.element.querySelector("div#floor_plan");
    const projectElements = floorPlan.querySelectorAll(':scope > div[id^="project_"]');
    if (!more_element && !projectElements ) return
    const floorPlanLength = projectElements.length + more_element.children.length
    if (floorPlanLength === 10) {
      if(this.hasAddMoreButtonTarget) {
        this.addMoreButtonTarget.classList.add("hidden")
      }
    }
    const element = this.element.querySelector("div#element_template");
    more_element.classList.remove("hidden");
    const id = Date.now()
    const trashIcon = element.querySelector('img.trash-icon');
    trashIcon.id = id
    let append_element = this.replaceUnusedString(element.innerHTML, id)

    append_element = `
      <div class="floor-plan-contain__form" id="project_${id}">
        ${append_element}
      </div>
    `
    more_element.insertAdjacentHTML('beforeend', append_element)
  }

  remove(e){
    const destroy_flag = document.getElementById(`destroy_floor_plan_${e.target.id}`)
    const project_form = document.getElementById(`project_${e.target.id}`);
    if(this.hasAddMoreButtonTarget) {
      this.addMoreButtonTarget.classList.remove("hidden")
    }
    if (!destroy_flag) return project_form.remove();

    project_form.classList.add("hidden");
    destroy_flag.value = "true";
  }

  replaceUnusedString(html, id){
    return html
      .replace(/(input--error|input__message|\[element_template\])/g, (match) => {
      switch (match) {
        case 'input--error':
          return '';
        case 'input__message':
          return 'hidden';
        case '[element_template]':
          return `[floor_plans_attributes][${id}]`
        default:
          return match;
      }
    });
  }
}
